import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardNextEventContext = createContext(null);
const timeRanges = [
  'Past 7 days',
  'Past 30 days'
];

// declare provider component
const CardNextEventProvider = ({ children }) => {
  const [nextEvent, setNextEvent] = useState(null);
  const [nextEventLoading, setNextEventLoading] = useState(null);
  const [nextEventError, setNextEventError] = useState(null);

  const [schedule, setSchedule] = useState(null);
  const [scheduleVisibleMonth, setScheduleVisibleMonth] = useState(new Date());
  const [scheduleLoading, setScheduleLoading] = useState(null);
  const [scheduleError, setScheduleError] = useState(null);

  const [latestCheckIn, setLatestCheckIn] = useState(null);
  const [latestCheckInLoading, setLatestCheckInLoading] = useState(null);
  const [latestCheckInError, setLatestCheckInError] = useState(null);
  
  const setTheNextEvent = (nextEvent) => {
    if (logComponent('CardNextEventContext')) { console.debug('CardNextEventContext setTheNextEvent'); }
    let newNextEvent = nextEvent ? { ...nextEvent } : null;
    setNextEvent(newNextEvent);
  }

  const setTheNextEventLoading = (nextEventLoading) => {
    if (logComponent('CardNextEventContext')) { console.debug('CardNextEventContext setTheNextEventLoading'); }
    let newNextEventLoading = nextEventLoading;
    setNextEventLoading(newNextEventLoading);
  }

  const setTheNextEventError = (nextEventError) => {
    if (logComponent('CardNextEventContext')) { console.debug('CardNextEventContext setTheNextEventError'); }
    let newNextEventError = nextEventError;
    setNextEventError(newNextEventError);
  }



  const cardState = useMemo(() => ({
    nextEvent,
    nextEventLoading,
    nextEventError,
    setNextEvent: setTheNextEvent,
    setNextEventLoading: setTheNextEventLoading,
    setNextEventError: setTheNextEventError
  }), [
    nextEvent,
    nextEventLoading,
    nextEventError
]);

  return (
    <CardNextEventContext.Provider value={ cardState }>
      {children}
    </CardNextEventContext.Provider>
  );
}

// export provider and context
export { CardNextEventContext, CardNextEventProvider };